var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockClosedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9.33333H16.375V7.52381C16.375 5.03571 14.4062 3 12 3C9.59375 3 7.625 5.03571 7.625 7.52381V9.33333H6.75C5.7875 9.33333 5 10.1476 5 11.1429V20.1905C5 21.1857 5.7875 22 6.75 22H17.25C18.2125 22 19 21.1857 19 20.1905V11.1429C19 10.1476 18.2125 9.33333 17.25 9.33333ZM12 17.4762C11.0375 17.4762 10.25 16.6619 10.25 15.6667C10.25 14.6714 11.0375 13.8571 12 13.8571C12.9625 13.8571 13.75 14.6714 13.75 15.6667C13.75 16.6619 12.9625 17.4762 12 17.4762ZM14.7125 9.33333H9.2875V7.52381C9.2875 5.98571 10.5125 4.71905 12 4.71905C13.4875 4.71905 14.7125 5.98571 14.7125 7.52381V9.33333Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosedIcon);
export default __webpack_public_path__ + "static/media/lock-closed-icon.65c0492c.svg";
export { ForwardRef as ReactComponent };